export default __webpack_public_path__ + "static/352-6828c3c7e062d1dd48651a3f3931cb30.gif";